import React from 'react';

/** Rail du cockpit — structure et VRAIES classes du prototype (`.rail`). */

const ICON: Record<string, string> = {
  dispatch: 'M12 2 4 6v6c0 5 3.4 9.4 8 10 4.6-.6 8-5 8-10V6l-8-4Z',
  synoptique: 'M3 4h7v7H3V4Zm11 0h7v4h-7V4ZM3 13h7v7H3v-7Zm11-2h7v9h-7v-9Z',
  'main-courante': 'M5 3h11l3 3v15H5V3Zm3 6h8v1.6H8V9Zm0 4h8v1.6H8V13Zm0 4h5v1.6H8V17Z',
  sites: 'M4 21V8l6-4 6 4v13h-5v-5H9v5H4Zm14 0V10l2 1.4V21h-2Z',
  reseau: 'M3 13h11l2-5h4l1 5v5h-2a2 2 0 1 1-4 0H9a2 2 0 1 1-4 0H3v-5Z',
  planning: 'M7 2h2v2h6V2h2v2h3v18H4V4h3V2Zm13 8H4v10h16V10ZM6 12h4v3H6v-3Z',
  formations: 'M12 3 1 8l11 5 9-4.1V16h2V8L12 3ZM5 12.2V16c0 1.7 3.1 3 7 3s7-1.3 7-3v-3.8l-7 3.2-7-3.2Z',
  technologies: 'M11 2h2v5h-2V2Zm-7 7h5v2H4V9Zm11 0h5v2h-5V9Zm-4 4h2v9h-2v-9Zm-4-4h10v2H7V9Z',
  alliances: 'M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm-8 9a8 8 0 0 1 16 0H4Z',
  stats: 'M3 3h2v18H3V3Zm4 10h3v8H7v-8Zm5-6h3v14h-3V7Zm5 3h3v11h-3V10Z',
  succes: 'M5 3h14v2h2v4a4 4 0 0 1-4 4h-.6A5 5 0 0 1 13 15.9V18h3v2H8v-2h3v-2.1A5 5 0 0 1 7.6 13H7a4 4 0 0 1-4-4V5h2V3Zm0 4H4v2a2 2 0 0 0 1 1.7V7Zm14 0v3.7A2 2 0 0 0 20 9V7h-1Z',
  reglages: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm9.4 4c0-.6-.1-1.2-.2-1.8l2.1-1.6-2-3.5-2.5 1a8.9 8.9 0 0 0-3-1.7L15.4 1h-4l-.4 2.7c-1.1.3-2.1.9-3 1.6l-2.5-1-2 3.5 2.1 1.6a9.6 9.6 0 0 0 0 3.5L3.5 14.5l2 3.5 2.5-1c.9.7 1.9 1.3 3 1.6l.4 2.7h4l.4-2.7c1.1-.3 2.1-.9 3-1.6l2.5 1 2-3.5-2.1-1.6c.1-.6.2-1.2.2-1.8Z',
  aide: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 15h-2v-2h2v2Zm1.8-6.3-.9.9c-.6.6-.9 1.1-.9 2.4h-2v-.5c0-1 .4-1.9 1.1-2.6l1.2-1.2c.4-.4.6-.9.6-1.4a2 2 0 0 0-4 0H8a4 4 0 0 1 8 0c0 .8-.3 1.6-.9 2.2Z',
  panel: 'M3 4h18v4H3V4Zm0 6h8v10H3V10Zm10 0h8v4h-8v-4Zm0 6h8v4h-8v-4Z',
  dashboard: 'M10 4h8v16h-8v-2h6V6h-6V4Zm-1 4 3 4-3 4v-3H3v-2h6V8Z',
};

/** kind : `ops` = vue dans le workspace (is-active) ; `drawer` = tiroir overlay
 *  (is-open) ; `nav` = navigation hors cockpit (jamais actif). */
type ItemKind = 'ops' | 'drawer' | 'nav';

interface Item {
  key: string;
  label: string;
  kind: ItemKind;
  extra?: string;
  kbd?: string;
}

const OPS: Item[] = [
  { key: 'dispatch', label: 'Dispatch', kind: 'ops', kbd: '1' },
  { key: 'synoptique', label: 'Synoptique', kind: 'ops', kbd: '2' },
  { key: 'main-courante', label: 'Main cour.', kind: 'ops', kbd: '3' },
];
const GESTION: Item[] = [
  { key: 'sites', label: 'Sites', kind: 'drawer', extra: 'rail__item--mgmt' },
  { key: 'reseau', label: 'Réseau', kind: 'drawer', extra: 'rail__item--mgmt' },
  { key: 'planning', label: 'Planning', kind: 'drawer', extra: 'rail__item--mgmt' },
  { key: 'formations', label: 'Formations', kind: 'drawer', extra: 'rail__item--mgmt' },
  { key: 'technologies', label: 'Technos', kind: 'drawer', extra: 'rail__item--mgmt' },
  { key: 'alliances', label: 'Alliances', kind: 'drawer', extra: 'rail__item--mgmt' },
  { key: 'stats', label: 'Stats', kind: 'drawer', extra: 'rail__item--mgmt' },
];
const BOTTOM: Item[] = [
  { key: 'succes', label: 'Succès', kind: 'drawer', extra: 'rail__item--aide' },
  { key: 'reglages', label: 'Réglages', kind: 'drawer', extra: 'rail__item--mgmt' },
  { key: 'aide', label: 'Aide', kind: 'drawer', extra: 'rail__item--aide', kbd: '?' },
  { key: 'panel', label: 'Panel', kind: 'nav', extra: 'rail__item--panel', kbd: 'P' },
  { key: 'dashboard', label: 'Dashboard', kind: 'nav', extra: 'rail__item--exit' },
];

interface Props {
  /** Vue Ops active (dispatch / synoptique / main-courante). */
  active: string;
  /** Clé du tiroir de gestion ouvert, ou null. */
  openDrawer?: string | null;
  onNavigate: (key: string) => void;
  showPanel?: boolean;
}

const RailBtn: React.FC<{ it: Item; state: boolean; onNavigate: (k: string) => void }> = ({ it, state, onNavigate }) => {
  const stateClass = it.kind === 'drawer' ? (state ? 'is-open' : '') : it.kind === 'ops' ? (state ? 'is-active' : '') : '';
  return (
    <button
      className={`rail__item ${it.extra || ''} ${stateClass}`}
      onClick={() => onNavigate(it.key)}
      title={it.label}
      type="button"
    >
      <svg viewBox="0 0 24 24"><path d={ICON[it.key]} /></svg>
      <span>{it.label}</span>
      {it.kbd ? <kbd>{it.kbd}</kbd> : null}
    </button>
  );
};

const isOn = (it: Item, active: string, openDrawer?: string | null): boolean =>
  it.kind === 'ops' ? active === it.key : it.kind === 'drawer' ? openDrawer === it.key : false;

const CockpitRail: React.FC<Props> = ({ active, openDrawer = null, onNavigate, showPanel = false }) => (
  <nav className="rail">
    <p className="rail__group">Ops</p>
    {OPS.map((it) => (
      <RailBtn key={it.key} it={it} state={isOn(it, active, openDrawer)} onNavigate={onNavigate} />
    ))}
    <p className="rail__group rail__group--sep">Gestion</p>
    {GESTION.map((it) => (
      <RailBtn key={it.key} it={it} state={isOn(it, active, openDrawer)} onNavigate={onNavigate} />
    ))}
    <div className="rail__spacer" />
    {BOTTOM.filter((it) => it.key !== 'panel' || showPanel).map((it) => (
      <RailBtn key={it.key} it={it} state={isOn(it, active, openDrawer)} onNavigate={onNavigate} />
    ))}
  </nav>
);

/** Clés qui correspondent à des tiroirs de gestion (utilisé par le cockpit). */
export const DRAWER_KEYS = [...GESTION, ...BOTTOM].filter((it) => it.kind === 'drawer').map((it) => it.key);
/** Clés des vues Ops (workspace). */
export const OPS_KEYS = OPS.map((it) => it.key);

export default CockpitRail;
